import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BehaviorSubject, throwError} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {ActivatedRoute} from '@angular/router';
import {concatMap, map, tap, catchError} from 'rxjs/operators';
import * as moment from 'moment';
import { CustomAlertService } from 'src/app/_components/custom-alert/custom-alert.service';

const API_URL = environment.apiUrl;

@Injectable()
export class AsistenciaCursoService {

  private urlParamsSubject = new BehaviorSubject({fecha: '', mcpID: 0});
  urlParamsChange$ = this.urlParamsSubject.asObservable()
    .pipe(
      map(data => data)
    );

  asistenciaCurso$ = this.urlParamsChange$.pipe(
    concatMap(data =>
      this.http.get(`${API_URL}/api/Asistencia/alumnos/materia/${data.mcpID}${!data.fecha ? '' : '/fecha/' + data.fecha}`)
    )
  );

  listPendientes$ = this.urlParamsChange$.pipe(
    concatMap(data =>
      this.http.get<any[]>(`${API_URL}/api/Asistencia/pendiente/materia/${data.mcpID}`)
        .pipe(
          map(fechas => fechas), //.map(fecha => moment(fecha.substring(0, 10)))),
          catchError(err => {
            this.customAlertService.setCustomMessage({
              tipo: 'error',
              texto: `Se ha presentado un error al traer la información. Inténtelo nuevamente. <br> Código de error: ${err.statusText}`
            });
            return [];
          })
        )
    )
  );

  constructor(private http: HttpClient,
              private route: ActivatedRoute,
              private customAlertService: CustomAlertService) {
  }

  setUrlParams(params: { fecha, mcpID }) {
    this.urlParamsSubject.next(params);
  }

  private handleError(err: any) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    let errorMessage: string;
    if (err.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage = `Backend returned code ${err.status}(${err.statusText}): ${err.error}`;
    }
    return throwError(errorMessage);
  }
}
